import { useDispatch } from "react-redux";

import { fetchAgentMatches } from "../../slices/agentMatchSlice";
import { useAgentMatchData } from "./useAgentMatchData";

export const useAgentMatchBehavior = () => {
  const dispatch = useDispatch();
  const { propertyId } = useAgentMatchData();

  return {
    fetchAgentMatches: () => dispatch(fetchAgentMatches(propertyId))
  };
};
